import h from 'snabbdom/h';
import styles from './styles';
import { isSceneLoaded, isSceneRendered, loadingProgress, numErrors } from '../modules/sceneIO';

var stats = statsReporter();

function statsReporter() {
  var pageLoadTime, toRenderedTime;
  if (typeof performace === 'undefined') return function () {};

  return function (store, pct) {
    if (pageLoadTime && toRenderedTime) return;
    if (!pageLoadTime) pageLoadTime = new Date().getTime() - performance.timing.navigationStart;
    if (pct < 1) return;
    toRenderedTime = new Date().getTime() - performance.timing.navigationStart;
    console.log(`Page loaded in ${pageLoadTime}ms and rendered in ${toRenderedTime}ms`);
  };
};

//
var spinnerColor = '#646766';

var circleDiv = {
  flex: '0 0 25%',
};

var r = 90;
var PIR2 = Math.PI * r * 2;

var outer = {
  r, cx: 100, cy: 100,
  fill: 'transparent',
  'stroke-dasharray': PIR2,
  'stroke-dashoffset': 0,
  'stroke-width': '1em',
  stroke: '#eee',
};
var inner = {
  r, cx: 100, cy: 100,
  fill: 'transparent',
  stroke: spinnerColor,
  transition: 'stroke-dashoffset 1s linear',
  'stroke-width': '1em',
  'stroke-dashoffset': PIR2,
  'stroke-dasharray': PIR2,
};
var svg = {
  height: '100%',
  width: '100%',
  viewport: '0 0 100 100',
  viewBox: '0 0 200 200',
};

export default function progress(store) {
  const pct = loadingProgress(store);
  const degrees = PIR2 * (1 - pct);
  stats(store, pct);

  return h('div', { style: { ...styles.absoluteMaxCentered, backgroundColor: 'transparent', boxSizing: 'border-box' } }, [
    h('div', { style: circleDiv }, [
      h('svg', { attrs: svg }, [
        h('circle', { attrs: outer }),
        h('circle', { props: { id: 'bar' }, attrs: { ...inner, 'stroke-dashoffset': degrees } }),
      ]),
    ]),
  ]);
}




// WEBPACK FOOTER //
// ./src/components/progress.js